import { useState } from "react";
import { X } from "lucide-react";

export default function AnnouncementBar() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 left-0 right-0 z-[60] bg-[#0A0A0A] text-white"
    >
      <div className="flex items-center justify-center h-8 sm:h-9 px-10 sm:px-6">
        <p
          className="block sm:hidden text-[9px] tracking-[0.15em] uppercase text-center whitespace-nowrap"
          style={{ fontStyle: "normal" }}
        >
          Oktober Drop &nbsp;·&nbsp; 20% Off First Order
        </p>
        <p
          className="hidden sm:block text-[10px] sm:text-xs tracking-[0.25em] uppercase text-center"
          style={{ fontStyle: "normal" }}
        >
          New Collection End of Oktober &nbsp;&mdash;&nbsp; 20% Off Your First Order
        </p>
        <button
          data-testid="close-announcement"
          onClick={() => setVisible(false)}
          className="absolute right-3 sm:right-4 text-white/60 hover:text-white transition-colors"
        >
          <X className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
        </button>
      </div>
    </div>
  );
}
